import {
  Button,
  DatePicker,
  Input,
  Layout,
  Modal,
  PageHeader,
  Select,
  Tag,
  Typography,
  Row,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table';
import styled from 'styled-components';
import HeaderComponent from '../../components/HeaderComponent';

import Tappable from 'react-tappable/lib/Tappable';
import { showError } from '../../utils';

import {
  fetchAllCenterDataUpdateRequests,
  updateBankDetails,
  updateRequestStatus,
  updateZohoId,
} from '../../services/api/center-update-requests';
import { addNetworkSpoc, saveMouDetailsForCenter } from '../../services';
import SidebarComponent from '../../components/sidebarComponent';

const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;
const { success, warning } = Modal;
const { Content } = Layout;
const { RangePicker } = DatePicker;

const TappableContainer = styled(Tappable)`
  margin: 10px;
`;
const CenterDataUpdateRequests = () => {
  const [approvalRequests, setApprovalRequests] = useState([]);
  const [combinedApprovalRequest, setCombinedApprovalRequest] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [selectedApprovalRequest, setSelectedApprovalRequest] = useState({});
  const [isSidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchAllRequests();
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const pendingRequests =
      approvalRequests &&
      approvalRequests.filter((item) => item.status === 'Pending');
    const remainingRequests = approvalRequests.filter(
      (item) => item.status !== 'Pending'
    );
    const combinedData = pendingRequests.concat(remainingRequests);

    setCombinedApprovalRequest(combinedData);
  }, [approvalRequests]);

  useEffect(() => {
    const data = approvalRequests.find(
      ({ requestId }) => requestId === selectedRequestId
    );
    if (data) {
      setSelectedApprovalRequest(data);
      setShowModal(true);
    }
  }, [selectedRequestId]);

  const fetchAllRequests = async () => {
    const data = await fetchAllCenterDataUpdateRequests();
    if (data.body) {
      const page = Math.ceil(data.body.data / pageSize);
      setPages(page);
      setApprovalRequests(data.body.data);
      setLoading(false);
      console.log(data.body, 'fetchAllRequests');
    }
  };

  const handleRequestCancellation = async () => {
    if (selectedApprovalRequest.status === 'Pending') {
      const data = await updateRequestStatus({
        requestId: selectedRequestId,
        status: 'Rejected',
      });
      console.log(data);
      if (data.body.message == 'success') {
        setSelectedApprovalRequest({});
        setSelectedRequestId('');
        setShowModal(false);
        alert('Request rejected successfully!');
        fetchAllRequests();
      }
    } else {
      alert('Request is already approved or rejected!');
    }
  };

  const handleSubmit = async () => {
    if (selectedApprovalRequest.status != 'Pending') {
      alert('Request is already approved or rejected!');
      return;
    }
    if (selectedApprovalRequest.requestType === 'Add_SPOC_Details') {
      const data = await addNetworkSpoc({
        centerId: selectedApprovalRequest.centerId,
        name: selectedApprovalRequest.spocName,
        email: selectedApprovalRequest.spocEmail,
        phone: selectedApprovalRequest.spocPhone,
        type: selectedApprovalRequest.spocType,
        sendWhatsApp: selectedApprovalRequest.sendWhatsapp,
        sendEmail: selectedApprovalRequest.sendEmail,
        sendCC: selectedApprovalRequest.sendCC,
        sendSMS: selectedApprovalRequest.sendSms,
        sendCall: selectedApprovalRequest.sendCall,
        commType: selectedApprovalRequest.commsType,
      });
      if (data.message == 'success') {
        const updateResponse = await updateRequestStatus({
          requestId: selectedRequestId,
          status: 'Approved',
        });
        console.log(updateResponse);
        if (updateResponse.body.message == 'success') {
          setSelectedApprovalRequest({});
          setSelectedRequestId('');
          setShowModal(false);
          alert('Request Approved successfully!');
          fetchAllRequests();
        }
      } else {
        const err = new Error('Invalid response');
        err.data = data.body;
        showError(err);
        throw err;
      }
    }
    if (selectedApprovalRequest.requestType === 'Add_Zoho_Details') {
      const data = await updateZohoId({
        centerId: selectedApprovalRequest.centerId,
        zohoId: selectedApprovalRequest.ZohoId,
        fulfilmentId: selectedApprovalRequest.fulfilmentId,
      });
      console.log(data);
      if (data.body.message == 'success') {
        const updateResponse = await updateRequestStatus({
          requestId: selectedRequestId,
          status: 'Approved',
        });
        console.log(updateResponse, 'updateResponse');
        if (updateResponse.body.message == 'success') {
          setSelectedApprovalRequest({});
          setSelectedRequestId('');
          setShowModal(false);
          alert('Request Approved successfully!');
          fetchAllRequests();
        }
      } else {
        const err = new Error('Invalid response');
        err.data = data.body;
        showError(err);
        throw err;
      }
    }
    if (selectedApprovalRequest.requestType === 'Add_PAN_Number') {
      const payload = {
        centerId: selectedApprovalRequest.centerId,
        mouCategory: selectedApprovalRequest.mouCategory,
        mouStatus: selectedApprovalRequest.mouStatus || 1,
        panName: selectedApprovalRequest.panName,
        finalMouIds: [selectedApprovalRequest.mouId],
        documentType: selectedApprovalRequest.documentType,
        panNumber: selectedApprovalRequest.panNumber,
      };
      const data = await saveMouDetailsForCenter(payload);
      console.log(data);
      if (data.message == 'success') {
        const updateResponse = await updateRequestStatus({
          requestId: selectedRequestId,
          status: 'Approved',
        });
        console.log(updateResponse, 'updateResponse');
        if (updateResponse.body.message == 'success') {
          setSelectedApprovalRequest({});
          setSelectedRequestId('');
          setShowModal(false);
          alert('Request Approved successfully!');
          fetchAllRequests();
        }
      } else {
        const err = new Error('Invalid response');
        err.data = data.body;
        showError(err);
        throw err;
      }
    }
    if (selectedApprovalRequest.requestType === 'Add_Bank_Details') {
      const payload = {
        centerId: selectedApprovalRequest.centerId,
        fulfilmentId: selectedApprovalRequest.fulfilmentId,
        fulfilmentType: selectedApprovalRequest.fulfilmentType,
        upiAddress: selectedApprovalRequest.upiAddress,
        upiPhone: selectedApprovalRequest.upiPhone,
        payeeName: selectedApprovalRequest.payeeName,
        accountNumber: selectedApprovalRequest.accountNumber,
        ifscCode: selectedApprovalRequest.ifscCode,
        accountType: selectedApprovalRequest.accountType,
      };
      const data = await updateBankDetails(payload);
      console.log(data);
      if (data.body.message == 'success') {
        const updateResponse = await updateRequestStatus({
          requestId: selectedRequestId,
          status: 'Approved',
        });
        console.log(updateResponse, 'updateResponse');
        if (updateResponse.body.message == 'success') {
          setSelectedApprovalRequest({});
          setSelectedRequestId('');
          setShowModal(false);
          alert('Request Approved successfully!');
          fetchAllRequests();
        }
      } else {
        const err = new Error('Invalid response');
        err.data = data.body;
        showError(err);
        throw err;
      }
    }
  };

  const tableColumns = [
    {
      accessor: 'requestId',
      filterable: false,
      Header: 'Request Id',
      Cell: (row) => {
        return (
          <div style={{ textAlign: 'center' }}>
            <Button
              className="request-id-button"
              onClick={() => {
                setSelectedRequestId(row.original.requestId);
              }}
            >
              {row.original.requestId}
            </Button>
          </div>
        );
      },
    },
    {
      accessor: 'centerName',
      sortable: true,
      filterable: false,
      Header: 'Center Name',
    },
    {
      accessor: 'createdAt',
      filterable: false,
      Header: 'Requested Date',
    },
    {
      accessor: 'requestType',
      filterable: false,
      Header: 'Request Type',
      Cell: (row) => {
        let requestType = row.original.requestType;
        requestType = requestType.replaceAll('_', ' ');

        return <div style={{ textAlign: 'center' }}>{requestType}</div>;
      },
    },
    {
      accessor: 'status',
      Header: 'Status',
      filterable: true,
      sortable: true,
      filterMethod: (filter, row) => {
        if (filter.value === 'all') {
          return true;
        }
        return row.status === filter.value;
      },
      Filter: ({ filter, onChange }) => {
        return (
          <select
            onChange={(event) => onChange(event.target.value)}
            style={{ width: '100%' }}
            value={filter ? filter.value : 'all'}
          >
            <option value="all">All Requests</option>
            <option value="Pending">Pending</option>
            <option value="Rejected">Rejected</option>
            <option value="Approved">Approved</option>
          </select>
        );
      },
      Cell: (row) =>
        row.original.status === 'Pending' ? (
          <Tag color="red">{row.original.status}</Tag>
        ) : row.original.status === 'Approved' ? (
          <Tag color="cyan">{row.original.status}</Tag>
        ) : row.original.status === 'Rejected' ? (
          <Tag color="magenta">{row.original.status}</Tag>
        ) : (
          <Tag color="yellow">{row.original.status}</Tag>
        ),
    },
    {
      accessor: 'createdBy',
      filterable: false,
      Header: 'Requested By',
    },
    {
      accessor: 'approvedBy',
      filterable: false,
      Header: 'Claimed By',
    },
  ];

  return (
    <Layout>
      <div>
        <HeaderComponent />
        <div style={{
          display: 'flex',
        }}>
          <div style={{ zIndex: 1000 }}>

            <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
          </div>
          <div style={{ width: '100%' }}>

      <Content className="site-layout-background" >
        <PageHeader
          className="site-page-header"
          title="Center Update Requests"
        />
        <ReactTable
          data={combinedApprovalRequest}
          columns={tableColumns}
          loading={loading}
          className="-striped -highlight"
          textAlign="center"
          minRows={1}
          showPaginationTop
          showPaginationBottom
        />
        <Modal
          title={`Approval Request for Change in Center Details : ${selectedRequestId}`}
          visible={showModal}
          okText="Approve"
          cancelText="Reject"
          onCancel={(e) => {
            if (e.currentTarget.id === 'discardButton') {
              handleRequestCancellation();
            } else {
              setShowModal(false);
              setSelectedRequestId(null);
              setSelectedApprovalRequest({});
            }
          }}
          cancelButtonProps={{ id: 'discardButton' }}
          onOk={handleSubmit}
        >
          <Row>
            <div style={{ marginBottom: '5px', display: 'flex' }}>
              <label style={{ minWidth: '200px' }}> Center Id :</label>
              <label>{selectedApprovalRequest.centerId}</label>
            </div>
            <div style={{ marginBottom: '5px', display: 'flex' }}>
              <label style={{ minWidth: '200px' }}>
                {' '}
                Network Center Name :
              </label>
              <label>{selectedApprovalRequest.centerName}</label>
            </div>
            <div style={{ marginBottom: '5px', display: 'flex' }}>
              <label style={{ minWidth: '200px' }}> Request Type :</label>
              <label>
                {selectedApprovalRequest.requestType &&
                  selectedApprovalRequest.requestType.replaceAll('_', ' ')}
              </label>
            </div>

            {selectedApprovalRequest.requestType === 'Add_SPOC_Details' && (
              <>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Spoc Name :</label>
                  <label>{selectedApprovalRequest.spocName}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Spoc Email :</label>
                  <label>{selectedApprovalRequest.spocEmail}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}>
                    {' '}
                    Spoc Phone Number :
                  </label>
                  <label>{selectedApprovalRequest.spocPhone}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Spoc Type :</label>
                  <label>{selectedApprovalRequest.spocType}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}>
                    {' '}
                    Spoc Comms Type :
                  </label>
                  <label>{selectedApprovalRequest.commsType}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Send WhatsApp :</label>
                  <label>
                    {selectedApprovalRequest.sendWhatsapp ? 'Yes' : 'No'}
                  </label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Send SMS :</label>
                  <label>
                    {selectedApprovalRequest.sendEmail ? 'Yes' : 'No'}
                  </label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Send Email :</label>
                  <label>
                    {selectedApprovalRequest.sendEmail ? 'Yes' : 'No'}
                  </label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Send Call :</label>
                  <label>
                    {selectedApprovalRequest.sendCall ? 'Yes' : 'No'}
                  </label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Send CC :</label>
                  <label>{selectedApprovalRequest.sendCC ? 'Yes' : 'No'}</label>
                </div>
              </>
            )}
            {selectedApprovalRequest.requestType === 'Add_PAN_Number' && (
              <>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}>
                    {' '}
                    Name on PAN Card :
                  </label>
                  <label>{selectedApprovalRequest.panName}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Pan Number :</label>
                  <label>{selectedApprovalRequest.panNumber}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Pan Documents :</label>
                  <label>
                    <a>{selectedApprovalRequest.panDocLink}</a>
                  </label>
                </div>
              </>
            )}
            {selectedApprovalRequest.requestType === 'Add_Zoho_Details' && (
              <>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}> Zoho Id :</label>
                  <label>{selectedApprovalRequest.ZohoId}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}>
                    {' '}
                    Zoho Display Name :
                  </label>
                  <label>{selectedApprovalRequest.ZohoDisplayName}</label>
                </div>
                <div style={{ marginBottom: '5px', display: 'flex' }}>
                  <label style={{ minWidth: '200px' }}>
                    {' '}
                    Zoho Company Name :
                  </label>
                  <label>
                    <a>{selectedApprovalRequest.ZohoCompanyName}</a>
                  </label>
                </div>
              </>
            )}
            {selectedApprovalRequest.requestType === 'Add_Bank_Details' && (
              <>
                {selectedApprovalRequest.upiAddress && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> UPI Address :</label>
                    <label>{selectedApprovalRequest.upiAddress}</label>
                  </div>
                )}
                {selectedApprovalRequest.upiAddress && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> UPI Number :</label>
                    <label>{selectedApprovalRequest.upiPhone}</label>
                  </div>
                )}
                {selectedApprovalRequest.payeeName && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> Payee Name :</label>
                    <label>{selectedApprovalRequest.payeeName}</label>
                  </div>
                )}
                {selectedApprovalRequest.accountNumber && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}>
                      {' '}
                      Account Number :
                    </label>
                    <label>{selectedApprovalRequest.accountNumber}</label>
                  </div>
                )}
                {selectedApprovalRequest.accountType && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> Account Type :</label>
                    <label>{selectedApprovalRequest.accountType}</label>
                  </div>
                )}
                {selectedApprovalRequest.ifscCode && (
                  <div style={{ marginBottom: '5px', display: 'flex' }}>
                    <label style={{ minWidth: '200px' }}> IFSC Code :</label>
                    <label>{selectedApprovalRequest.ifscCode}</label>
                  </div>
                )}
              </>
            )}
          </Row>
        </Modal>
      </Content>
      </div></div></div>
    </Layout>
  );
};

export default withRouter(CenterDataUpdateRequests);
